export default {
    collapseButton: {
        collapse: "Collapse",
        expand: "Expand"
    }
};
